<template>
    <LoaderCar v-if="loading" width="600px" marginTop="0"/>
    <div class="container-home" v-else>
        <HeaderHome :user="this.$store.state.user.prenom"/>
        <template v-if="this.$store.state.user.role.label == 'eleve'">
            <HomeEleve :dossierEleve="this.dossier"/>
        </template>
        <template v-if="this.$store.state.user.role.label == 'secretaire'">
            <HomeAgence />
        </template>
        <template v-if="this.$store.state.user.role.label == 'moniteur'">
            <HomeMoniteur />
        </template>
    </div>
</template>
<script>

import HomeEleve from "../components/home/HomeEleve.vue";
import HeaderHome from "../components/home/HeaderHome.vue";
import HomeAgence from "../components/home/HomeAgence.vue";
import HomeMoniteur from "../components/home/HomeMoniteur.vue";
import LoaderCar from "../components/LoaderCar.vue";

export default {
    name: "HomeBis",

    components: {
        HomeEleve,
        HeaderHome,
        HomeAgence,
        HomeMoniteur,
        LoaderCar
    },

    data() {
        return {
            dossier: null,
            loading : true,
        }
    },

    mounted() {
        if(this.$store.state.user.role.label == 'eleve' && this.$store.state.user.dossier !== null){
            this.loadDossier();
        }else{
            this.loading = false;
        }
    },

    methods: {
        loadDossier() {
        window.api
            .post(
            "/dossier/home",
            {
                dossierId: this.$store.state.user.dossier.id,
                dossier: {},
            },
            {
                headers: {
                Authorization: "Bearer " + this.$store.state.token,
                },
            }
            )
            .then((response) => {
            this.dossier = response.data;
            this.loading = false;
            })
            .catch((error) => {
            console.log(error);
            });
        },
    },
}
</script>
<style scoped>

    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
    .spinner-group {
        transform-origin: 340px 130px;
        animation: spin 1s linear infinite;
    }

    div.loading-eleve{
        width: 600px;
        margin: auto;
        margin-top: 5rem;
    }

    div.container-home{
        background-color: #F4F6F9;
        min-height: 100vh;
        padding-bottom: 1rem;
    }
</style>